import axiosInstance from './axiosConfig';

export const validateToken = async (token) => {
    try {
      const config = {
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        },
    };

        const response = await axiosInstance.get('users/validateToken', config);
        return response.data;
    } catch (err) {
        console.error('Token validation failed:', err);
        return null;
    }
};